import { render } from "./payPage.vue?vue&type=template&id=3bd398b0&scoped=true"
import script from "./payPage.vue?vue&type=script&lang=js"
export * from "./payPage.vue?vue&type=script&lang=js"

import "./payPage.vue?vue&type=style&index=0&id=3bd398b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd398b0"]])

export default __exports__